'use client';

import { alpha, Button, styled, Theme } from "@mui/material";
import { ChevronLeft, ChevronRight } from "@mui/icons-material";
import { SxProps } from "@mui/system";

interface ImageGalleryNavigationProps {
    onPrevious: () => void;
    onNext: () => void;
}

export default function ImageGalleryNavigation({ onPrevious, onNext }: ImageGalleryNavigationProps) {

    const commonSx: SxProps<Theme> = (theme) => ({
        position: 'absolute',
        top: '50%',
        transform: 'translate(0, -50%)',
        height: "96px",
        width: "32px",
        backgroundColor: alpha(theme.palette.background.paper, 0.75),
    })

    return (
        <div className="image-gallery-navigation z-50">
            <PreviousButton
                variant="outlined"
                aria-label="Vorheriges Bild"
                onClick={onPrevious}
                sx={(theme) => ({
                    ...commonSx(theme),
                    left: theme.spacing(2),
                })}
            >
                <ChevronLeft style={{ fontSize: 72 }}/>
            </PreviousButton>
            <NextButton
                variant="outlined"
                aria-label="Nächstes Bild"
                onClick={onNext}
                sx={(theme) => ({
                    ...commonSx(theme),
                    right: theme.spacing(2),
                })}
            >
                <ChevronRight style={{ fontSize: 72 }}/>
            </NextButton>
        </div>
    )
}

const PreviousButton = styled(Button)(({ theme }) => ({
    position: 'absolute',
    left: theme.spacing(2),
    top: '50%',
    transform: 'translate(0, -50%)',
    height: "50%",
}))

const NextButton = styled(Button)(({ theme }) => ({
    position: 'absolute',
    right: theme.spacing(2),
    top: '50%',
    transform: 'translate(0, -50%)',
    height: "50%",
}))
